import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberVertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronGrabberVertical"><Path d="M8 15L12 19L16 15" stroke="currentColor" strokeLinecap="square"/><Path d="M8 9L12 5L16 9" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronGrabberVertical;
